<template>
  <v-row justify="center">
    <v-dialog v-model="showDialog" persistent :max-width="maxWidthModal">
      <v-card>
        <v-card-title class="headline">{{ title }}</v-card-title>
        <v-card-text class="ui form">
          <div class="ui grid" style="margin-bottom: 5px;">
            <div class="eight wide column">
            </div>
            <div class="six wide column right aligned">
              <label>Pesquisar:</label>
            </div>
            <div class="two wide column">
              <input
                v-model="search"
                type="text"
                autocomplete="off"
              />
            </div>
          </div>
          <div class="table-scroll">
            <v-data-table
              :headers="
                [
                  {text: 'Equipamento', value: 'codigo'},
                  {text: 'Descrição', value: 'produtoDescricao'},
                  {text: 'Série Fabricante', value: 'seriefabricante'},
                  {text: 'Modelo', value: 'modelo'},
                  {text: 'Marca', value: 'marca'},
                  {text: 'Tipo', value: 'tipo'},
                  {text: 'Ordem Serviço', value: 'oservico', align: 'center aligned'},
                  {text: 'Data', value: 'data'},
                ]
              "
              :items="lista"
              :items-per-page="10"
              class="ui table very compact celled selectable dataTable" style="width: 100%; white-space: nowrap;"
              :search="search"
            >
              <template v-slot:item.data="{ item }">
                <span> {{ formatarData(item.data) }} </span>
              </template>
              <template v-slot:item.codigo="{ item }">
                <button type="button" class="ui button label blue small" @click="showEquipamento(item.recnum)"> {{ item.codigo }} </button>
              </template>
              <template v-slot:item.oservico="{ item }">
                <button type="button" class="ui button label blue small" @click="showOS(item.oservico)"> {{ item.oservico }} </button>
              </template>
            </v-data-table>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="close">Fechar</v-btn>
          <slot name="button"></slot>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapState } from 'vuex';
import moment from 'moment';
import openTab from '@/services/tabs';

export default {
  name: 'ModalUserLogged',
  props: ['title', 'dados', 'maxWidth'],
  data() {
    return {
      search: '',
      maxWidthModal: this.maxWidth ? this.maxWidth : 900,
      lista: [],
    };
  },
  computed: {
    ...mapState('global', {
      showDialog: state => state.modal,
    }),
  },
  methods: {
    close() {
      this.$store.commit('global/closeModal');
    },
    formatarData(data) {
      return moment(data).format('DD/MM/YYYY');
    },
    showEquipamento(recnum) {
      openTab('scp010a1', 'Equipamento', {
        EXTRECNO: recnum,
        ACAO: 22,
      }, null);
    },
    showOS(oservico) {
      openTab('scp100a1', 'Ordem de Serviço', {
        CODIGO: oservico,
        ACAO: 22,
      }, null);
    },
  },
  watch: {
    dados: {
      immediate: false,
      handler(novosDados) {
        this.lista = novosDados;
      },
    },
  },
};
</script>
<style lang="scss">
  .ui.small.table {
    font-size: 11px;
  }
</style>
